module.exports = __webpack_public_path__ + "static/media/audience-preferred.82397423.svg";